import * as React from 'react';

import { ProjectModel } from 'franke-trough-dependencies';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { ProjectEditForm } from 'src/app/Partials';
import LoadingSpinner from 'src/app/Partials/LoadingSpinner/LoadingSpinner';
import { Redirect } from 'react-router';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ProjectsEdit.messages';

import './ProjectsEdit.scss';


export interface ProjectEditProps {
  dispatch: any;
  project: GlobalPrivateState['project'];
}

export interface ProjectEditState {
  redirect: boolean;
}

export class ProjectEditPartial extends React.Component<ProjectEditProps, ProjectEditState> {
  constructor(props: ProjectEditProps) {
    super(props);
    this.state = {
      redirect: false,
    };
    this.submitted = this.submitted.bind(this);
  }
  public render() {
    return (
      <div className="page-configuration-rename d-flex justify-content-center align-items-center flex-wrap vh-100 text-center">
        {this.props.project.updating && !this.props.project.loaded && (
          <LoadingSpinner />
        )}
        {this.project && (
          <div className="container">
            <div className="row">
              <div className="col-8 offset-2">
                <h2 className="mb-4">
                  <FormattedMessage {...MESSAGES.projectsEditHeadline} />
                </h2>
                <ProjectEditForm 
                  submitted={this.submitted}
                />
              </div>
            </div>
          </div>
        )}
        {this.state.redirect && (
          <Redirect to="/profile/projects" />
        )}
      </div>
    );
  }

  private submitted(redirect: boolean) {
    this.setState({
      redirect,
    });
  }

  private get project(): ProjectModel | undefined {
    const { project } = this.props;
    return project && project.result;
  }
}

export const ProjectEdit = connect((state: GlobalPrivateState) => ({
  project: state.project,
}))(ProjectEditPartial);

export default ProjectEdit;
